import { BottomSheet } from './BottomSheet';
import { PassengerForm, PassengerData } from './PassengerForm';

interface PassengerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (passenger: PassengerData) => void;
  onDelete?: () => void;
  initialData?: PassengerData;
  mode: 'add' | 'edit';
}

export const PassengerModal = ({
  isOpen,
  onClose,
  onSave,
  onDelete,
  initialData,
  mode
}: PassengerModalProps) => {
  const title = mode === 'add' ? 'Nuevo pasajero' : 'Editar pasajero';

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} title={title}>
      <PassengerForm
        onSave={onSave}
        onCancel={onClose}
        onDelete={onDelete}
        initialData={initialData}
        mode={mode}
      />
    </BottomSheet>
  );
};
